export const FissionPositionManagerAbi = [
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: 'uint8', name: 'version', type: 'uint8' },
    ],
    name: 'Initialized',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Paused',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Unpaused',
    type: 'event',
  },
  {
    inputs: [],
    name: 'FISSION_POSITION_MANAGER_ADMIN_ROLE',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'tokenId_', type: 'uint256' },
      { internalType: 'uint256', name: 'fundTokensAmount_', type: 'uint256' },
      { internalType: 'uint256', name: 'usdcTokensAmount_', type: 'uint256' },
    ],
    name: 'addLiquidity',
    outputs: [
      { internalType: 'uint256', name: 'fundTokensUsed_', type: 'uint256' },
      { internalType: 'uint256', name: 'usdcTokensUsed_', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'tokenId_', type: 'uint256' },
      { internalType: 'uint256', name: 'fundTokensAmount_', type: 'uint256' },
      { internalType: 'uint256', name: 'usdcTokensAmount_', type: 'uint256' },
      {
        components: [
          {
            components: [
              { internalType: 'address', name: 'token', type: 'address' },
              { internalType: 'uint160', name: 'amount', type: 'uint160' },
              { internalType: 'uint48', name: 'expiration', type: 'uint48' },
              { internalType: 'uint48', name: 'nonce', type: 'uint48' },
            ],
            internalType: 'struct IAllowanceTransfer.PermitDetails[]',
            name: 'details',
            type: 'tuple[]',
          },
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'sigDeadline', type: 'uint256' },
        ],
        internalType: 'struct IAllowanceTransfer.PermitBatch',
        name: 'permitBatchAllowanceData_',
        type: 'tuple',
      },
      { internalType: 'bytes', name: 'signature_', type: 'bytes' },
    ],
    name: 'addLiquidityWithPermit2',
    outputs: [
      { internalType: 'uint256', name: 'fundTokensUsed_', type: 'uint256' },
      { internalType: 'uint256', name: 'usdcTokensUsed_', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'tokenId_', type: 'uint256' }],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'tokenId_', type: 'uint256' },
      {
        internalType: 'uint128',
        name: 'liquidityToDecrease_',
        type: 'uint128',
      },
      { internalType: 'uint256', name: 'fundAmountMin_', type: 'uint256' },
      { internalType: 'uint256', name: 'usdcAmountMin_', type: 'uint256' },
      { internalType: 'uint256', name: 'deadline_', type: 'uint256' },
      { internalType: 'address', name: 'recipient_', type: 'address' },
    ],
    name: 'close',
    outputs: [
      {
        internalType: 'uint256',
        name: 'fundTokensCollected_',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'usdcTokensCollected_',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'tokenId_', type: 'uint256' },
      { internalType: 'address', name: 'recipient_', type: 'address' },
      { internalType: 'uint256', name: 'fundAmountMax_', type: 'uint256' },
      { internalType: 'uint256', name: 'usdcAmountMax_', type: 'uint256' },
    ],
    name: 'collect',
    outputs: [
      {
        internalType: 'uint256',
        name: 'fundTokensCollected_',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'usdcTokensCollected_',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'int24', name: 'tickLower_', type: 'int24' },
      { internalType: 'int24', name: 'tickUpper_', type: 'int24' },
      { internalType: 'uint256', name: 'fundTokensAmount_', type: 'uint256' },
      { internalType: 'uint256', name: 'usdcTokensAmount_', type: 'uint256' },
    ],
    name: 'createPosition',
    outputs: [
      { internalType: 'uint256', name: 'positionTokenId_', type: 'uint256' },
      { internalType: 'uint256', name: 'fundTokensUsed_', type: 'uint256' },
      { internalType: 'uint256', name: 'usdcTokensUsed_', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'int24', name: 'tickLower_', type: 'int24' },
      { internalType: 'int24', name: 'tickUpper_', type: 'int24' },
      { internalType: 'uint256', name: 'fundTokensAmount_', type: 'uint256' },
      { internalType: 'uint256', name: 'usdcTokensAmount_', type: 'uint256' },
      {
        components: [
          {
            components: [
              { internalType: 'address', name: 'token', type: 'address' },
              { internalType: 'uint160', name: 'amount', type: 'uint160' },
              { internalType: 'uint48', name: 'expiration', type: 'uint48' },
              { internalType: 'uint48', name: 'nonce', type: 'uint48' },
            ],
            internalType: 'struct IAllowanceTransfer.PermitDetails[]',
            name: 'details',
            type: 'tuple[]',
          },
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'sigDeadline', type: 'uint256' },
        ],
        internalType: 'struct IAllowanceTransfer.PermitBatch',
        name: 'permitBatchAllowanceData_',
        type: 'tuple',
      },
      { internalType: 'bytes', name: 'signature_', type: 'bytes' },
    ],
    name: 'createPositionWithPermit2',
    outputs: [
      { internalType: 'uint256', name: 'positionTokenId_', type: 'uint256' },
      { internalType: 'uint256', name: 'fundTokensUsed_', type: 'uint256' },
      { internalType: 'uint256', name: 'usdcTokensUsed_', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'tokenId_', type: 'uint256' },
      {
        internalType: 'uint128',
        name: 'liquidityToDecrease_',
        type: 'uint128',
      },
      { internalType: 'uint256', name: 'fundAmountMin_', type: 'uint256' },
      { internalType: 'uint256', name: 'usdcAmountMin_', type: 'uint256' },
      { internalType: 'uint256', name: 'deadline_', type: 'uint256' },
    ],
    name: 'decreaseLiquidity',
    outputs: [
      {
        internalType: 'uint256',
        name: 'fundTokensDecreased_',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'usdcTokensDecreased_',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'fissionVault',
    outputs: [
      { internalType: 'contract IFissionVault', name: '', type: 'address' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'fundTokenAddr',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getInjector',
    outputs: [{ internalType: 'address', name: 'injector_', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          { internalType: 'address', name: 'fundTokenAddr', type: 'address' },
          { internalType: 'address', name: 'usdcTokenAddr', type: 'address' },
        ],
        internalType:
          'struct IFissionPositionManager.FissionPositionManagerInitParams',
        name: 'initParams_',
        type: 'tuple',
      },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'pause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'paused',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'permissionManager',
    outputs: [
      {
        internalType: 'contract IPermissionManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'permit2',
    outputs: [{ internalType: 'contract IPermit2', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'positionManager',
    outputs: [
      {
        internalType: 'contract INonfungiblePositionManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'priceManager',
    outputs: [
      { internalType: 'contract IPriceManager', name: '', type: 'address' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'contractsRegistryAddr_',
        type: 'address',
      },
      { internalType: 'bytes', name: '', type: 'bytes' },
    ],
    name: 'setDependencies',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'injector_', type: 'address' }],
    name: 'setInjector',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'unpause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'usdcTokenAddr',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
] as const
